// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import annotationQuestionIcon from "@/assets/icons/annotation-question.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type AnnotationQuestionIconProps = Omit<IconProps, "name">;

export function AnnotationQuestionIcon(props: AnnotationQuestionIconProps): React.ReactNode {
  return <Icon name={annotationQuestionIcon} {...props} />;
}
